import { db } from "../../../../../firebaseConfig";
import { auth } from "../../../../../firebaseConfig";
import {
  doc,
  setDoc,
  deleteDoc,
  collection,
  query,
  orderBy,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";

/**
 * Save post to user's saved collection
 * @param {Object} post - Post to save
 */
export const savePost = async (post) => {
  try {
    const { currentUser } = auth;
    if (!currentUser) throw new Error("No authenticated user");

    const savedPostRef = doc(
      db,
      "users",
      currentUser.uid,
      "savedPosts",
      post.id,
    );
    await setDoc(savedPostRef, {
      ...post,
      savedAt: serverTimestamp(),
    });
  } catch (error) {
    console.error("Error saving post:", error);
    throw error;
  }
};

/**
 * Unsave post from user's saved collection
 * @param {string} postId - Post ID
 */
export const unsavePost = async (postId) => {
  try {
    const { currentUser } = auth;
    if (!currentUser) throw new Error("No authenticated user");

    const savedPostRef = doc(
      db,
      "users",
      currentUser.uid,
      "savedPosts",
      postId,
    );
    await deleteDoc(savedPostRef);
  } catch (error) {
    console.error("Error unsaving post:", error);
    throw error;
  }
};

/**
 * Get user's saved posts
 * @returns {Promise<Array>} - Saved posts
 */
export const getSavedPosts = async () => {
  try {
    const { currentUser } = auth;
    if (!currentUser) throw new Error("No authenticated user");

    const savedPostsRef = collection(
      db,
      "users",
      currentUser.uid,
      "savedPosts",
    );
    const q = query(savedPostsRef, orderBy("savedAt", "desc"));
    const snapshot = await getDocs(q);

    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
      savedAt: doc.data().savedAt?.toDate() || new Date(),
    }));
  } catch (error) {
    console.error("Error getting saved posts:", error);
    throw error;
  }
};
